import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { getTopPlayersApi } from '../../api/match.api';
import { getFileUrl } from '../../utils/media';

const TABS = [
  { key: 'goals', label: 'برترین گلزنان', unit: 'گل', emoji: '⚽' },
  { key: 'assists', label: 'برترین پاس‌گل‌ها', unit: 'پاس گل', emoji: '🎯' },
];

const MEDALS = { 1: '🥇', 2: '🥈', 3: '🥉' };

export default function TopPlayersCard({ tournamentId, limit = 10 }) {
  const [tab, setTab] = useState('goals');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);

    getTopPlayersApi({ sortBy: tab, limit, tournamentId: tournamentId || undefined })
      .then(({ data }) => active && setRows(data?.data || []))
      .catch(() => active && setRows([]))
      .finally(() => active && setLoading(false));

    return () => {
      active = false;
    };
  }, [tab, limit, tournamentId]);

  const current = TABS.find((t) => t.key === tab);

  return (
    <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white">
      <div className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-slate-800 to-emerald-900 px-6 py-6 text-white">
        <div className="absolute -left-10 -top-16 h-40 w-40 rounded-full bg-amber-400/10" />
        <div className="relative flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="grid h-12 w-12 place-items-center rounded-2xl bg-white/10 text-2xl">{current.emoji}</div>
            <div>
              <h3 className="text-lg font-black">{current.label}</h3>
              <p className="text-xs text-white/60">بر اساس آمار ثبت‌شده‌ی مسابقات برگزارشده</p>
            </div>
          </div>

          <div className="flex rounded-full bg-white/10 p-1">
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`rounded-full px-4 py-1.5 text-xs font-black transition ${
                  tab === t.key ? 'bg-white text-slate-900' : 'text-white/70 hover:text-white'
                }`}
              >
                {t.key === 'goals' ? 'گل' : 'پاس گل'}
              </button>
            ))}
          </div>
        </div>
      </div>

      {loading ? (
        <div className="py-12 text-center text-sm text-slate-400">در حال بارگذاری...</div>
      ) : rows.length === 0 ? (
        <div className="py-12 text-center text-sm text-slate-400">هنوز آماری برای نمایش ثبت نشده است</div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {rows.map((r) => {
            const photo = getFileUrl(r.player.photo);
            const value = tab === 'goals' ? r.goals : r.assists;

            return (
              <li key={r.player.id}>
                <Link
                  to={`/players/${r.player.id}`}
                  className={`flex items-center gap-4 px-5 py-3 transition hover:bg-emerald-50/60 ${
                    r.rank === 1 ? 'bg-amber-50/50' : ''
                  }`}
                >
                  <div className="w-8 text-center text-lg font-black text-slate-400">
                    {MEDALS[r.rank] || r.rank}
                  </div>

                  <div className="grid h-11 w-11 shrink-0 place-items-center overflow-hidden rounded-full bg-slate-100 ring-2 ring-white">
                    {photo ? (
                      <img src={photo} alt="" className="h-full w-full object-cover" />
                    ) : (
                      <Icon name="userCircle" className="h-6 w-6 text-slate-400" />
                    )}
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="truncate text-sm font-black text-slate-800">
                      {r.player.firstName} {r.player.lastName}
                    </div>
                    <div className="truncate text-xs text-slate-400">
                      {r.player.club?.name || '—'} • {r.matches} بازی
                    </div>
                  </div>

                  <div className="text-center">
                    <div className="text-2xl font-black text-emerald-600">{value}</div>
                    <div className="text-[10px] font-bold text-slate-400">{current.unit}</div>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
